import { useState, useEffect, useCallback } from 'react'
import { Language, translations, TranslationKey } from './translations'

export function useLanguage() {
  const [language, setLanguage] = useState<Language>(() => {
    const saved = localStorage.getItem('language')
    return saved === 'en' || saved === 'zh' || saved === 'ja' ? saved : 'en'
  })

  useEffect(() => {
    localStorage.setItem('language', language)
  }, [language])

  const t = useCallback(
    (key: TranslationKey) => {
      return translations[language][key] || translations['en'][key] || key
    },
    [language],
  )

  return { language, setLanguage, t }
}
